module.exports = __webpack_public_path__ + "static/media/mbSwagingMachinesforRailwaycablesdesktop.45beb671.jpg";